import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { showRequestErrors } from '@softline/application';
import { Store } from '@softline/core';
import { ZusatzartikelStore } from '../store';
import { SOFTLINE_FEATURE_TRANSPORTAUFTRAG_ZUSATZARTIKEL } from '../transport.shared';

@Component({
  selector: 'soft-tp-transport',
  imports: [RouterModule],
  templateUrl: './transport.component.html',
  styleUrls: ['./transport.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportComponent implements OnInit {
  private readonly store = inject(Store);

  async ngOnInit(): Promise<void> {
    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_TRANSPORTAUFTRAG_ZUSATZARTIKEL,
        ZusatzartikelStore.actions.load
      );
    } catch (e) {
      showRequestErrors(this.store, e);
    }
  }
}
